import styled from '@emotion/styled'

// AccentText — italic + accent-colored span. Used for the editorial accent
// inside display headings (e.g. "Klimb <em>Studio</em>" or
// "designed to <em>disappear</em>"). Reaches for tokens so it reskins
// cleanly across surfaces.
export const AccentText = styled.em`
  font-style: italic;
  color: var(--c-accent);
`
